// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23zJV","left":"styles_left__3qKlQ"};